'use client';

import LinkLocalized from '@/components/nav/LinkLocalized';
import BurgerMenu from '@/components/nav/BurgerMenu';
import { useSupabase } from '@/components/providers/SupabaseProvider';
import SignUpButton from '@/components/buttons/SignUpButton';
import { useState, useEffect } from 'react';
import { HeaderLink } from '@/components/nav/HeaderLink';
import LogInButton from '@/components/buttons/LogInButton';
import SearchBar from '@/components/SearchBar';
import Image from 'next/image';
import { useTheme } from 'next-themes';

export type NavItem = {
  href: string;
  icon: string;
  label: string;
  pattern: string;
};

export const navItems: NavItem[] = [
  {
    href: '/foods',
    icon: '🥦',
    label: 'Foods',
    pattern: '/food',
  },
  {
    href: '/nutrients',
    icon: '💠',
    label: 'Nutrients',
    pattern: '/nutrient',
  },
  {
    href: '/faq',
    icon: '💬',
    label: 'F.A.Q.',
    pattern: '/faq',
  },
  {
    href: '/account',
    icon: '👤',
    label: 'Account',
    pattern: '/account',
  },
];

export default function Header() {
  const { session } = useSupabase();

  const [mounted, setMounted] = useState(false);
  const { resolvedTheme } = useTheme();
  const logo =
    resolvedTheme === 'dark'
      ? '/mynutribase-logo-dark.png'
      : '/mynutribase-logo.png';

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <header className="sticky left-0 top-0 z-10 flex h-14 items-center justify-between border-b bg-white px-3 shadow-sm dark:border-gray-800 dark:bg-gray-900">
      <LinkLocalized
        href="/"
        className="mr-2 flex flex-1 flex-shrink-0 text-xl"
      >
        <div className="relative h-6 w-10 flex-shrink-0 md:mt-0.5">
          {mounted && (
            <Image
              src={logo}
              alt="mynutribase logo"
              priority
              fill
              sizes="40px"
            />
          )}
        </div>

        <div className="ml-0.5 hidden md:flex">
          <span className="font-semibold text-lime-600 dark:text-lime-100">
            my
          </span>
          <span className="font-bold text-lime-800 dark:text-lime-500">
            nutribase
          </span>
        </div>
        {/* <span className="text-lime-500">base</span> */}
      </LinkLocalized>

      <SearchBar />

      <div className="hidden h-full items-center justify-around px-3 capitalize lg:flex">
        {[...navItems].splice(0, navItems.length - 1).map((item) => (
          <HeaderLink key={item.label} item={item} />
        ))}
      </div>

      <div className="flex flex-1 shrink-0 items-center justify-end">
        <div className="hidden font-bold lg:flex lg:shrink-0 lg:items-center lg:space-x-2">
          {session ? (
            <HeaderLink item={navItems[navItems.length - 1]} />
          ) : (
            <>
              <LogInButton />
              <SignUpButton />
            </>
          )}
        </div>

        {/* <SearchBar /> */}
        <BurgerMenu navItems={navItems} />
      </div>
    </header>
  );
}
